import { render, staticRenderFns } from "./dailyRevenNewUser.vue?vue&type=template&id=35e5362b&"
import script from "./dailyRevenNewUser.vue?vue&type=script&lang=js&"
export * from "./dailyRevenNewUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35e5362b')) {
      api.createRecord('35e5362b', component.options)
    } else {
      api.reload('35e5362b', component.options)
    }
    module.hot.accept("./dailyRevenNewUser.vue?vue&type=template&id=35e5362b&", function () {
      api.rerender('35e5362b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/dailyRevenNewUser.vue"
export default component.exports